import http from '@/assets/common/http';
// 新增部门
export function submitDepartment(data) {
  const params = {
    SERVICE_ID: '10053',
    OTYPE: 10,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 修改部门
export function editDepartment(data) {
  const params = {
    SERVICE_ID: '10053',
    OTYPE: 11,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 禁用部门
export function stopDepartment(data) {
  const params = {
    SERVICE_ID: '10053',
    OTYPE: 12,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 解除禁用
export function openDepartment(data) {
  const params = {
    SERVICE_ID: '10053',
    OTYPE: 13,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// 拉取部门
export function queryDepartment(data) {
  const params = {
    SERVICE_ID: '10053',
    OTYPE: 14,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}



// WEBPACK FOOTER //
// ./src/assets/api/productDepart.js